import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../core/services/user.service';
import { PermissionService } from '../../core/services/permission.service';

/**
 * Displayed when a user's account is not fully configured.
 *
 * Hotel users: need at least 1 hotel + 1 access area assigned.
 * Internal users: need a role assigned.
 */
@Component({
  selector: 'app-setup-incomplete',
  standalone: false,
  templateUrl: './setup-incomplete.component.html',
  styleUrl: './setup-incomplete.component.scss',
})
export class SetupIncompleteComponent implements OnInit {
  isInternalUser: boolean;
  reason: string = '';
  showDetails: boolean = false;

  constructor(
    private userService: UserService,
    private permissionService: PermissionService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.isInternalUser = this.permissionService.isInternal();
  }

  ngOnInit(): void {
    // Prefer query param from guard redirect, fall back to computing it directly
    this.reason = this.route.snapshot.queryParamMap.get('reason')
      || this.permissionService.getSetupIncompleteReason()
      || '';
  }

  toggleDetails(): void {
    this.showDetails = !this.showDetails;
  }

  logout(): void {
    this.userService.logout().subscribe({
      next: () => {
        this.router.navigate(['/account/login']);
      },
      error: () => {
        // Even on error, navigate to login
        this.router.navigate(['/account/login']);
      }
    });
  }
}
